import { render, staticRenderFns } from "./OnboardingUserRole.vue?vue&type=template&id=03e3f07c&"
import script from "./OnboardingUserRole.vue?vue&type=script&lang=ts&"
export * from "./OnboardingUserRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports